import { createStore } from 'vuex'
import { router } from './router'
import { createApp } from 'vue'
// import { createApp } from 'vue/dist/vue.esm-bundler';
import VueClickAway from "vue3-click-away";
// import * as Sentry from "@sentry/vue";
import { VueCookieNext } from 'vue-cookie-next'

let app = createApp({})
app.use(VueCookieNext)
VueCookieNext.config({ expire: '7d' })

// Sentry.init({
//   app,
//   environment: process.env.NODE_ENV,
//   dsn: "https://16b29b54bc434afaac2a33793f6d7243@o1051705.ingest.sentry.io/6034862",
//   integrations: [
//     Sentry.browserTracingIntegration({ router }),
//   ],
//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 0.3,
// });

/**
 * vue components
 * auto-import all vue components
 */
const vueComponents = require.context('./components/', true, /\.(vue|js)$/)

vueComponents.keys().forEach(key => {
  const component = vueComponents(key).default

  // if a component has a name defined use the name, else use the path as the component name
  const name = component.name ?
    component.name :
    key.replace(/\.(\/|vue|js)/g, '').replace(/(\/|-|_|\s)\w/g, (match) => match.slice(1).toUpperCase())

  app.component(name, component)
})

/**
 * vuex
 * auto-import all modules
 */

const vuexModules = require.context('./store/', true, /\.js$/)
const modules = {}

vuexModules.keys().forEach(key => {
  const name = key.replace(/\.(\/|js)/g, '').replace(/\s/g, '-')
  modules[name] = vuexModules(key).default
})

const store = createStore({
  strict: process.env.NODE_ENV !== 'production',
  modules
})

/**
 * vue mixins
 * auto-register all mixins with a 'global' keyword in their filename
 */
const mixins = require.context('./mixins/', true, /.*global.*\.js$/)

mixins.keys().forEach(key => {
  app.mixin(mixins(key).default)
})

/**
 * vue directives
 * auto-register all directives with a 'global' keyword in their filename
 */
const directives = require.context('./directives/', true, /.*global.*\.js$/)

directives.keys().forEach(key => {
  const directive = directives(key).default
  app.directive(directive.name, directive.directive)
})

/**
 * vue prototype
 * extend with additional features
 */

/**
 * vue plugins
 * extend with additional features
 */
// register additional plugins here

app
  .use(router)
  .use(store)
  .use(VueClickAway)

app.config.globalProperties.$swipers = window.$swipers
app.mount("#app");